export default {
  FIRST: 'first',
  SECOND: 'second',
  THIRD: 'third',
};
